export const Environment = {
    PROD: 'PROD',
    LEGACY: 'LEGACY',
    PROD2: 'PROD2',
    NEW: 'NEW',
    STAGING: 'STAGING',
    BETA: 'BETA',
    ALPHA: 'ALPHA',
    DEV: 'DEV',
    LOCAL: 'LOCAL'
}

export default Environment
